export const ORDER_READY_ADOPTION = 'order-ready-adoption';
